<i class="b-radius-max"
   [ngClass]="['flag-' + siteId.replace('_trade', '') | lowercase, dropDownFlag ? 'drop-down-flag' : simpleMultisite ? 'flag-dim-simple' : 'flag-dim']"
   aria-hidden="true"></i>
